import BotAPI from 'app/api/BotAPI'
import BotConstants from 'constants/BotConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'

class BotActions extends Marty.ActionCreators {
  fetchBot(orgId) {
    this.dispatch(BotConstants.FETCH_BOT_STARTED)
    return BotAPI
      .fetchOrCreate(orgId)
      .then((bot) => {
        return this.app.sources.UserAPI.fetchUser(bot.botId).then((res) => {
          if (res.status === 200) {
            const { name, orgId, avatarUrl } = res.body
            this.dispatch(BotConstants.FETCH_BOT_FINISHED, bot.set("name", name)
                                                                               .set("avatarUrl", avatarUrl)
                                                                               .set("orgId", orgId))
          } else {
            captureResponseException(res)
            this.dispatch(BotConstants.FETCH_BOT_FAILED)
          }
        })
      })
      .catch((error) => {
        captureException(error)
        this.dispatch(BotConstants.FETCH_BOT_FAILED)
      })
  }

  enableBot(orgId, enabled) {
    this.dispatch(BotConstants.ENABLE_BOT_STARTED)
    return BotAPI
      .enable(orgId, enabled)
      .then((bot) => this.dispatch(BotConstants.ENABLE_BOT_FINISHED, bot.enabled))
      .catch((error) => {
        captureException(error)
        this.dispatch(BotConstants.ENABLE_BOT_FAILED)
    })
  }

  updateBot(botId, properties) {
    this.dispatch(BotConstants.UPDATE_BOT_STARTED)
    return this.app.sources.UserAPI.updateUser(botId, properties).then((res) => {
      if (res.status === 200) {
        this.dispatch(BotConstants.UPDATE_BOT_FINISHED, properties)
        this.app.actions.NotificationActions.pushNotification({ content: "Your bot has been saved!" })
      } else {
        captureResponseException(res)
        this.dispatch(BotConstants.UPDATE_BOT_FAILED)
      }
    })
  }

  setBotAvatar(botId, file) {
    this.dispatch(BotConstants.UPLOAD_BOT_AVATAR_STARTED)
    return this.app.sources.UserAPI.uploadUserAvatar(botId, file).then((res) => {
      if (res.status === 200) {
        this.dispatch(BotConstants.UPLOAD_BOT_AVATAR_FINISHED, file)
        this.app.actions.NotificationActions.pushNotification({ content: "Your bot has been saved!" })
      } else {
        captureResponseException(res)
        this.dispatch(BotConstants.UPLOAD_BOT_AVATAR_FAILED)
      }
    })
  }
}

export default BotActions



// WEBPACK FOOTER //
// ./src/scripts/actions/BotActions.js